import api from '../config/configAPI';

class InternalChatPresenceService {
  async getStatusForUser(login) {
    try {
      const response = await api.get('/user/status/all');
      const allStatuses = response.data;

      const userStatus = allStatuses.find((s) => s.login === login);

      if (userStatus) {
        if (!userStatus.isOnline) {
          return {
            login: userStatus.login,
            status: 'away'
          };
        }
        return {
          login: userStatus.login,
          status: userStatus.isBusy ? 'busy' : 'available'
        };
      }

      return {
        login,
        status: 'available'
      };
    } catch (error) {
      return {
        login,
        status: 'available'
      };
    }
  }

  async updateStatus(login, status) {
    try {
      if (status === 'available') {
        await api.patch(`/user/status/online/${login}`, { isOnline: true });
        await api.patch(`/user/status/busy/${login}`, { isBusy: false });
      } else if (status === 'busy') {
        await api.patch(`/user/status/online/${login}`, { isOnline: true });
        await api.patch(`/user/status/busy/${login}`, { isBusy: true });
      } else if (status === 'away') {
        await api.patch(`/user/status/online/${login}`, { isOnline: false });
      }

      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  }

  async getAllStatuses() {
    try {
      const response = await api.get('/user/status/all');
      const allStatuses = response.data;

      const statusMap = {};
      allStatuses.forEach((userStatus) => {
        if (!userStatus.isOnline) {
          statusMap[userStatus.login] = 'away';
        } else {
          statusMap[userStatus.login] = userStatus.isBusy
            ? 'busy'
            : 'available';
        }
      });

      return statusMap;
    } catch (error) {
      return {};
    }
  }
}
export default InternalChatPresenceService;
